import { createFileRoute, redirect } from '@tanstack/react-router'
import { zodValidator } from '@tanstack/zod-adapter'
import { useEffect, useRef } from 'react'
import { z } from 'zod'

import { useValidateMagicLink } from '@/api/domain/auth/magicLink.mutations'
import { useInviteRedirectStore } from '@/stores/inviteRedirect.store.ts'

const SEARCH_SCHEMA = z.object({
  token: z.string().optional(),
})

const MagicPage = () => {
  const { token } = Route.useSearch()
  const { mutate: validateLink } = useValidateMagicLink()
  const hasValidated = useRef(false)

  useEffect(() => {
    if (!token || hasValidated.current) {
      return
    }

    hasValidated.current = true

    validateLink({
      body: { token },
    })
  }, [token, validateLink])

  return <div className="animate-pulse p-4 text-sm">Signing in ...</div>
}

export const Route = createFileRoute('/auth/magic')({
  validateSearch: zodValidator(SEARCH_SCHEMA),
  beforeLoad: ({ search }) => {
    if (!search.token) {
      useInviteRedirectStore.getState().setErrorMessage('Invalid link')

      throw redirect({
        to: '/login',
        replace: true,
      })
    }
  },
  component: MagicPage,
})
